/* Pensum — Druckvorlage
   Baut aus dem Adressanker die Ansicht wieder auf, die der Kunde beim Kauf
   gesehen hat: Produktfoto mit Aufdruck an der gewählten Stelle. */
(function () {
  'use strict';

  var root = document.querySelector('[data-dv]');
  if (!root) return;

  var stage = root.querySelector('[data-dv-stage]');
  var photo = root.querySelector('[data-dv-photo]');
  var textEl = root.querySelector('[data-dv-text]');
  var symbolEl = root.querySelector('[data-dv-symbol]');
  var facts = root.querySelector('[data-dv-facts]');
  var actions = root.querySelector('[data-dv-actions]');
  var msg = root.querySelector('[data-dv-msg]');

  function melden(text) {
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = false;
  }

  /* ------------------------------------------------------------- Anker lesen */

  function ankerLesen() {
    var anker = window.location.hash.replace(/^#/, '');
    if (!anker) return null;

    var daten = {};
    anker.split('&').forEach(function (paar) {
      var trenner = paar.indexOf('=');
      if (trenner < 1) return;
      var schluessel = paar.slice(0, trenner);
      try {
        daten[schluessel] = decodeURIComponent(paar.slice(trenner + 1));
      } catch (e) {
        daten[schluessel] = paar.slice(trenner + 1);
      }
    });
    return daten;
  }

  // Aus dem Dateinamen im Anker wird die vollständige Adresse. Die Basis liefert
  // die Vorlage über Liquid, weil sie je Shop anders lautet.
  function bildAdresse(datei) {
    var basis = (window.PensumDruckvorlage || {}).dateiBasis || '';
    if (!datei) return '';
    if (/^https?:\/\//.test(datei) || datei.indexOf('//') === 0) return datei;
    var ohneAbfrage = basis.split('?')[0];
    return ohneAbfrage.substring(0, ohneAbfrage.lastIndexOf('/') + 1) + datei;
  }

  /* ------------------------------------------------------------- Aufbau */

  // Der Anteil bezieht sich auf die Bildbreite. Beim Ändern der Fenstergröße
  // muss die Schrift also mitwachsen, sonst wandert der Aufdruck.
  var groessen = [];

  function skalieren() {
    var breite = stage.clientWidth;
    if (!breite) return;
    groessen.forEach(function (eintrag) {
      eintrag.el.style.setProperty('--dv-fs', (breite * eintrag.anteil / 100) + 'px');
    });
  }

  function ebene(el, daten, praefix) {
    var inhalt = daten[praefix === 's' ? 's' : 't'];
    if (!inhalt) {
      el.hidden = true;
      return false;
    }

    el.textContent = inhalt;
    el.hidden = false;

    var x = daten[praefix === 's' ? 'sx' : 'x'];
    var y = daten[praefix === 's' ? 'sy' : 'y'];
    var z = daten[praefix === 's' ? 'sz' : 'z'];
    var schrift = daten[praefix === 's' ? 'sf' : 'f'];

    if (x) el.style.setProperty('--dv-x', x + '%');
    if (y) el.style.setProperty('--dv-y', y + '%');
    if (schrift) el.style.setProperty('--dv-font', '"' + schrift + '", serif');
    if (daten.i) el.style.setProperty('--dv-ink', '#' + daten.i.replace('#', ''));
    if (praefix !== 's' && daten.l) el.style.setProperty('--dv-track', daten.l);

    var anteil = parseFloat(z);
    if (!isNaN(anteil)) groessen.push({ el: el, anteil: anteil });

    return true;
  }

  function zeile(name, wert) {
    if (!wert) return;
    var li = document.createElement('li');
    var k = document.createElement('span');
    k.className = 'dv__key';
    k.textContent = name;
    var v = document.createElement('span');
    v.className = 'dv__val';
    v.textContent = wert;
    li.appendChild(k);
    li.appendChild(v);
    facts.appendChild(li);
  }

  /* ------------------------------------------------------- Als Bild speichern */

  function speichern() {
    var leinwand = document.createElement('canvas');
    var breite = photo.naturalWidth || stage.clientWidth;
    var hoehe = photo.naturalHeight || stage.clientHeight;
    if (!breite || !hoehe) return;

    leinwand.width = breite;
    leinwand.height = hoehe;
    var ctx = leinwand.getContext('2d');

    try {
      ctx.drawImage(photo, 0, 0, breite, hoehe);
    } catch (e) {
      melden('Das Bild lässt sich hier nicht speichern. Mach stattdessen einen Bildschirmausschnitt.');
      return;
    }

    // Dieselben Anteile wie in der Anzeige, nur auf die echte Bildgröße
    // gerechnet — dadurch sitzt der Aufdruck exakt wie in der Vorschau.
    groessen.forEach(function (eintrag) {
      var el = eintrag.el;
      if (el.hidden) return;

      var stil = getComputedStyle(el);
      var px = breite * eintrag.anteil / 100;
      var x = parseFloat(stil.getPropertyValue('--dv-x')) || 50;
      var y = parseFloat(stil.getPropertyValue('--dv-y')) || 50;

      ctx.save();
      ctx.font = px + 'px ' + stil.getPropertyValue('--dv-font');
      ctx.fillStyle = stil.getPropertyValue('--dv-ink') || '#111';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      // Sperrung gibt es auf der Leinwand nicht als Eigenschaft, deshalb
      // zeichenweise mit eigenem Abstand.
      var track = parseFloat(stil.getPropertyValue('--dv-track')) || 0;
      var abstand = track * px;
      var zeichen = el.textContent.split('');
      var gesamt = zeichen.reduce(function (summe, z) {
        return summe + ctx.measureText(z).width + abstand;
      }, 0) - abstand;

      var cursor = breite * x / 100 - gesamt / 2;
      ctx.textAlign = 'left';
      zeichen.forEach(function (z) {
        ctx.fillText(z, cursor, hoehe * y / 100);
        cursor += ctx.measureText(z).width + abstand;
      });
      ctx.restore();
    });

    var link = document.createElement('a');
    try {
      link.href = leinwand.toDataURL('image/png');
    } catch (e) {
      melden('Das Bild lässt sich hier nicht speichern. Mach stattdessen einen Bildschirmausschnitt.');
      return;
    }
    link.download = 'druckvorlage.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  /* ------------------------------------------------------------- Start */

  var daten = ankerLesen();
  if (!daten) {
    melden('Kein Auftrag angegeben. Öffne diese Seite über den Link „Druckvorlage" in der Bestellung.');
    return;
  }

  var adresse = bildAdresse(daten.b);
  if (adresse) {
    photo.addEventListener('load', function () {
      stage.hidden = false;
      skalieren();
      if (actions) actions.hidden = false;
    });
    photo.addEventListener('error', function () {
      stage.hidden = false;
      melden('Das Produktfoto konnte nicht geladen werden. Die Angaben unten stimmen trotzdem.');
    });
    photo.src = adresse;
  } else {
    melden('Zu dieser Farbe liegt kein Foto vor. Die Angaben unten stimmen trotzdem.');
  }

  ebene(symbolEl, daten, 's');
  ebene(textEl, daten, 't');

  facts.hidden = false;
  zeile('Aufdruck', daten.t);
  zeile('Schrift', daten.f);
  zeile('Druckfarbe', daten.i ? '#' + daten.i.replace('#', '') : '');
  zeile('Zeichen', daten.s);
  zeile('Position Aufdruck', daten.x && daten.y ? daten.x + ' % / ' + daten.y + ' %' : '');
  zeile('Position Zeichen', daten.sx && daten.sy ? daten.sx + ' % / ' + daten.sy + ' %' : '');

  window.addEventListener('resize', skalieren);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(skalieren).catch(function () {});
  }

  var knopf = root.querySelector('[data-dv-save]');
  if (knopf) knopf.addEventListener('click', speichern);
})();
